import Swiper from '@src/components/swiper';
import { screenResizerChecker } from '@src/utils/screen-resizer-checker';
import { ScreensInt } from '@tailwindConfig/screens.config';

export const swiperOptions = {
  loop: true,
  spaceBetween: 24,
  slidesPerView: 2,
  autoplay: {
    delay: false
  },
  speed: 5000,
  noSwipping: true,
  noSwipingClass: 'swiper-slide',
  breakpoints: {
    768: {
      slidesPerView: 4
    },
    1024: {
      slidesPerView: 7
    }
  }
};

const addSwiperCarousel = () => {
  new Swiper('.swiper-container-carousel', swiperOptions);
};

document.addEventListener('DOMContentLoaded', function (event) {
  screenResizerChecker(addSwiperCarousel, addSwiperCarousel, ScreensInt.md);
});
